// extracted by mini-css-extract-plugin
export default {"component":"_3HDUU"};